import React from "react";
import StyledH1Heading from "../../common/components/styledH1Heading/StyledH1Heading.tsx";
import StyledLgText from "../../common/components/styledLgText/StyledLgText.tsx";
import StyledH2Heading from "../../common/components/styledH2Heading/StyledH2Heading.tsx";
import Button from "../button/Button.tsx";
import { content } from "../../data.tsx";
import { useNavigate } from "react-router-dom";
import UseAuth from "../../utils/use-auth.ts";

const Home_discover = () => {
  const { user } = UseAuth();
  const navigate = useNavigate();

  return (
    <div className="w-full pt-[120px] pb-10 flex flex-col items-center justify-center">
      <div className="lg:flex-row flex gap-10 flex-col w-[95%] justify-center lg:justify-between items-center pb-20 max-w-[1280px]">
        <div className="w-[95%] text-center lg:w-[50%] gap-5 lg:text-start items-center justify-center lg:items-start lg:justify-start flex flex-col fade-up">
          <span className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-blue/8 border border-blue/15 text-blue text-xs font-medium tracking-wide uppercase">
            <span className="h-1.5 w-1.5 rounded-full bg-blue animate-pulse"></span>
            AI-powered coaching
          </span>
          <StyledH1Heading
            content={"Discover the Power of"}
            fontColor={"text-lightBlack"}
            customColor={"text-blue"}
            diffText={"Coach AI"}
            className=""
          />
          <StyledLgText
            children={
              "Discover the convenience and effectiveness of our state-of-the-art platform, designed with the precision of business coaching in mind. Enhance your professional growth with tools that match the quality of traditional coaching methods."
            }
            fontColor={"text-gray-500 max-w-xl"}
          />
          <div className="flex flex-col sm:flex-row gap-3 mt-3 w-full lg:w-auto">
            <div className="lg:w-auto">
              <Button
                children={user?.id ? "Start Chat" : "Get Started Free"}
                className="!w-auto !px-7 !py-3.5"
                onClick={() => navigate(user?.id ? "/chats" : "/signup")}
              />
            </div>
            <div className="lg:w-auto">
              <Button
                variant="secondary"
                children={"Learn More"}
                className="!w-auto !px-7 !py-3.5"
                onClick={() => navigate("/pricing")}
              />
            </div>
          </div>
        </div>
        <div className="w-[80%] lg:w-[45%] items-center justify-center rounded-3xl overflow-hidden relative">
          <div className="absolute -inset-4 bg-gradient-to-br from-blue/20 to-yellow/10 blur-3xl rounded-full opacity-60"></div>
          <img src="/assets/images/homesection1.png" alt="Coach AI hero" className="relative" />
        </div>
      </div>
      <div className="py-16 flex text-center flex-col items-center justify-center w-full">
        <StyledH2Heading
          regularContent={"Trusted by industry-leading companies around the globe"}
          regularFontColor={"text-lightBlack"}
        />
        <div className="flex lg:flex-row flex-col gap-10 lg:gap-12 w-full pt-10 justify-center items-center flex-wrap opacity-70">
          {content.leadingCompanies?.map((item, index) => (
            <div
              key={index}
              className="flex justify-center items-center grayscale hover:grayscale-0 transition-all duration-300"
            >
              <img src={item.imagUrl} alt="companies" className="w-[160px] lg:w-[180px]" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Home_discover;
